<template>
  <div id="remitent" class="pb-4">
    <form >
      <!-- Seccion superior con botones de acciones  -->
      <div class="row mb-2">
        <div class="col-12 d-flex justify-content-between flex-wrap">
          <div style="flex:1;" class="d-flex align-items-center">
            <h2 class="dashboard-title">Correo remitente</h2>
          </div>
          <div class="container-actions-dashboard d-flex justify-content-between mt-2 mt-sm-2 mt-md-0 mt-lg-0 mt-xl-0">
            <router-link to="/configuracion" tag="button" class="btn btn-outlined mr-2 d-flex align-items-center">
              <img src="@/assets/icons/undo.svg" alt width="15px" class="mr-2" />
              Regresar a configuración
            </router-link>
            <button
              class="btn btn-save mr-2 d-flex align-items-center"
              type="button"
              @click="submitForm()"
            >
              <i class="far fa-save mr-1"></i>
              Guardar cambios
            </button>
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <h6 class="content-text">
            Aquí podrás definir si quieres que el correo de las cotizaciones salga desde tu cuenta personal o bien, desde un correo de cotizarlo.com. En cualquiera de los casos, las respuestas de tu cliente se envían a tu cuenta de correo con la que creaste tu usuario en la plataforma.
          </h6>
        </div>
      </div>
      <!--FIN  Seccion superior con botones de acciones  -->

      <div class="row mt-3">
        <!-- Seccion card izquierdo -->
        <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12">
          <div class="cotizarlo-general-wrapper">
            <div class="card-body px-4 py-4">
              <div class="row">
                <div class="col-12">
                  <h3 class="subtitle-section">Envio de correos</h3>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="d-flex align-items-center mb-3">
                    <label class="switch m-0">
                      <input
                        class="form-check-input"
                        type="radio"
                        value="0"
                        name="prueba"
                        id="default"
                        :checked="mail_type == 0"
                        v-model="mail_type"
                      />
                      <span class="slider round"></span>
                    </label>
                    <span class="ml-2">Cotizarlo.com</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="inner-email-card">
                    <b>Correos salen de:</b> no-reply@cotizarlo.com
                    <br/>
                    <small>Cliente deberá crear un nuevo correo para responder.</small>
                    <!-- <small>Respuestas del cliente llegan a: {{ company.team.email }}</small> -->
                  </div>
                  <div class="mt-2">
                    <small class="text-muted">Esta opción es la más confiable en cuanto al envío</small>
                  </div>
                </div>
              </div>
              <hr>
              <div class="row">
                <div class="col-12">
                  <div class="d-flex align-items-center mb-3">
                    <label class="switch m-0">
                      <input
                        class="form-check-input"
                        type="radio"
                        value="1"
                        id="custom"
                        name="prueba"
                        :checked="mail_type == 1"
                        v-model="mail_type"
                      />
                      <span class="slider round"></span>
                    </label>
                    <span class="ml-2">Tu propio dominio</span>
                  </div>
                </div>
              </div>
              
              <div class="row" v-if="mail_type == 0">
                <div class="col-12">
                  <div class="inner-email-card">
                    <b>Correos salen de:</b> {{ company.team.email }}
                    <br/>
                    <small>Respuestas del cliente llegan a: {{ company.team.email }}</small>
                  </div>
                  <div class="mt-2">
                    <small class="text-muted">Si eliges está opción asegúrate de verificar tu dominio y evitar que tus cotizaciones se vayan al spam del cliente.</small>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="row">
                  <div class="col-12">
                    <small class="text-muted">Elige una opción de verificación. Ambas realizarán el envío desde la cuenta con la que te registraste en Cotizarlo.com</small>
                  </div>
                </div>
                <div class="row mt-2" v-if="mail_subtype == 0">
                  <div class="col-12">
                    <div class="d-flex flex-column">
                      <div class="d-flex" style="cursor:pointer;" @click="handleMailSubtype(1)">
                        <i class="icon-cot-archivero" style="transform:rotate(90deg);"></i>
                        <div class="ml-2">
                          <b>Vía SMTP</b>
                          (recomendada)
                        </div>
                      </div>
                      <hr class="my-2">
                      <div class="d-flex" style="cursor:pointer;" @click="handleMailSubtype(2)">
                        <i class="icon-cot-internet mr-2"></i>
                        <b>Vía Registro SPF</b>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Seccion cuando se selcciona smtp -->
                <div v-if="mail_subtype == 1">
                  <div class="row mt-2">
                    <div class="col-12">
                      <div class="d-flex align-items-center" style="cursor:pointer;" >
                        <i class="icon-cot-archivero" style="transform:rotate(90deg);"></i>
                        <div class="ml-2">
                          <b>Vía SMTP</b>
                          (recomendada)
                        </div>
                        <i class="icon-cot-tache ml-2" @click="handleMailSubtype(0)"></i>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-10">
                      <small class="text-muted">Sí ya conoces los datos SMTP de tu proveedor de correo electrónico, llénalos aquí abajo. De lo contrario, consulta instrucciones de algunos proveedores aquí:</small>
                    </div>
                  </div>
                  <!-- Seccion de logos  -->
                  <div class="row mt-2">
                    <div class="col-10">
                      <div class="d-flex flex-wrap w-100">
                        <div class="col-6 pl-0 mb-2">
                          <a class="form-control btn btn-outlined mr-2 d-flex align-items-center justify-content-center" href="https://sendgrid.com/docs/for-developers/sending-email/drupal/#using-the-smtp-authentication-support-module" target="_blank">
                            <img style="height:30px; width:100%;" src="@/assets/images/brand_mailing/sengrid.svg" alt="">
                          </a>
                        </div>
                        <div class="col-6 pl-0 mb-2">
                          <a class="form-control btn btn-outlined mr-2 d-flex align-items-center justify-content-center" href="https://aws.amazon.com/about-aws/whats-new/2011/12/13/amazon-simple-email-service-gets-simpler-with-smtp/" target="_blank">
                            <img style="height:30px; width:100%;" src="@/assets/images/brand_mailing/aws.svg" alt="">
                          </a>
                        </div>
                        <div class="col-6 pl-0 mb-2">
                          <a class="form-control btn btn-outlined mr-2 d-flex align-items-center justify-content-center" href="https://support.google.com/a/answer/176600?hl=es" target="_blank">
                            <img style="height:30px; width:100%;" src="@/assets/images/brand_mailing/google.svg" alt="">
                          </a>
                        </div>
                        <div class="col-6 pl-0 mb-2">
                          <a class="form-control btn btn-outlined mr-2 d-flex align-items-center justify-content-center" href="https://help.mailgun.com/hc/en-us/articles/203380100-Where-Can-I-Find-My-API-Key-and-SMTP-Credentials-" target="_blank">
                            <img style="height:30px; width:100%;" src="@/assets/images/brand_mailing/mailgun.svg" alt="">
                          </a>
                        </div>
                        <div class="col-6 pl-0 mb-2">
                          <a class="form-control btn btn-outlined mr-2 d-flex align-items-center justify-content-center" href="https://docs.microsoft.com/en-us/exchange/mail-flow-best-practices/how-to-set-up-a-multifunction-device-or-application-to-send-email-using-microsoft-365-or-office-365" target="_blank">
                            <img style="height:30px; width:100%;" src="@/assets/images/brand_mailing/microsoft.svg" alt="">
                          </a>
                        </div>
                        <div class="col-6 pl-0 mb-2">
                          <a class="form-control btn btn-outlined mr-2 d-flex align-items-center justify-content-center" href="https://help.sendinblue.com/hc/es/articles/209463245--C%C3%B3mo-puedo-activar-mi-cuenta-de-SendinBlue-SMTP-" target="_blank">
                            <img style="height:30px; width:100%;" src="@/assets/images/brand_mailing/sendinblue.svg" alt="">
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Seccion formulario -->
                  <div class="row mt-2">
                    <div class="col-10">
                      <div class="form-group">
                        <div class="input-field form-control" :class="{'is-invalid': $v.mail_configuration_smtp.host.$error}">
                          <input type="text" id="smpt_host" class="main-input" autocomplete="new-password" v-model="mail_configuration_smtp.host" placeholder="_" required/>
                          <label class="main-label" for="smpt_host">Servidor de correo. (Ej: mail.tudominio.com)</label>
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="input-field form-control" :class="{'is-invalid': $v.mail_configuration_smtp.port.$error}">
                          <input type="text" id="smtp_port" class="main-input" autocomplete="new-password" v-model="mail_configuration_smtp.port" placeholder="_" required/>
                          <label class="main-label" for="smtp_port">Puerto SMTP</label>
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="input-field form-control" :class="{'is-invalid': $v.mail_configuration_smtp.username.$error}">
                          <input type="email" id="smtp_username" class="main-input" autocomplete="new-mail" v-model="mail_configuration_smtp.username" placeholder="_" required/>
                          <label class="main-label" for="smtp_username">Usuario (tu correo electrónico)</label>
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="input-field form-control" :class="{'is-invalid': $v.mail_configuration_smtp.password.$error}">
                          <input type="password" id="smtp_password" class="main-input" autocomplete="new-password" v-model="mail_configuration_smtp.password" placeholder="_" required/>
                          <label class="main-label" for="smtp_password">Contraseña</label>
                        </div>
                      </div>
                      <div class="form-group w-100">
                        <button class="cotizarlo-select main-input dropdown-toggle w-100 d-flex align-items-center pl-2" type="button" id="menuTax" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" :class="{'is-invalid': $v.mail_configuration_smtp.encryption.$error}">
                          <span>{{mail_configuration_smtp.encryption_name}}</span>
                          <img class="dropdown-icon ml-auto" src="@/assets/icons/abajo.svg" width="15px"/>
                        </button>
                        <div class="dropdown-menu dropdown-select-menu w-100" aria-labelledby="menuTax" style="max-height:300px; overflow-y:scroll">
                          <div class="dropdown-item d-flex py-1" v-for="(method) in encrytion_types" :key="method.name" @click="selectMethod(method)">
                            <span>{{method.name}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-10">
                      <small class="text-muted">Llena la información de contacto con la que se enviará el correo. Te recomendamos poner el mismo correo que utilizaste para crear tu cuenta y tu nombre completo.</small>
                    </div>
                  </div>

                  <div class="row mt-2">
                    <div class="col-10">
                      <div class="form-group">
                        <div class="input-field form-control" :class="{'is-invalid': $v.mail_configuration_smtp.address.$error}">
                          <input type="text" id="smtp_address" class="main-input" autocomplete="new-password" v-model="mail_configuration_smtp.address" placeholder="_" required/>
                          <label class="main-label" for="smtp_address">Dirección de envío</label>
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="input-field form-control" :class="{'is-invalid': $v.mail_configuration_smtp.sender.$error}">
                          <input type="text" id="smtp_sender" class="main-input" autocomplete="new-password" v-model="mail_configuration_smtp.sender" placeholder="_" required/>
                          <label class="main-label" for="smtp_sender">Nombre de quién envía</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--FIN Seccion formulario -->
                  <!-- Seccion estatus y probar conexion -->
                  <div class="row mt-2">
                    <div class="col-10">
                      <div class="d-flex justify-content-between">
                        <div class="d-flex align-items-center">
                          <div class="bolita mr-2">
                            .
                          </div>
                          <div class="status">
                            <span v-if="mail_status == 0">Activo</span>
                            <span v-if="mail_status == 1">Error</span>
                          </div>
                        </div>
                        <div class="ml-auto">
                          <button class="btn btn-outlined p-2 d-flex align-items-center" type="button" style="height:auto; font-size:12px;" @click="testConection('smtp')">
                            <i class="fas fa-redo mr-1"></i>
                            REVISAR CONEXIÓN
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Seccion cuando se selecciona spf -->
                <div v-if="mail_subtype == 2">
                  <div class="row mt-2">
                    <div class="col-12">
                      <div class="d-flex align-items-center" style="cursor:pointer;" >
                        <i class="icon-cot-internet mr-2"></i>
                        <div>
                          <b>Vía registro SPF</b>
                        </div>
                        <i class="icon-cot-tache ml-2" @click="handleMailSubtype(0)"></i>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-2">
                    <div class="col-12">
                      <div class="form-group mt-2 d-flex align-items-center">
                        <div class="input-field form-control m-0">
                          <input type="text" id="spf_mail" class="main-input" autocomplete="new-password" placeholder="_" required/>
                          <label for="spf_mail" class="main-label">Teclea tu dominio: www.empresa.com</label>
                        </div>
                        <i class="icon-cot-guardar mx-2" style="font: size 1.2em; cursor:pointer;" @click="submitSpfForm()"></i>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-2">
                    <div class="col-12">
                      <div class="inner-email-card">
                        <b>Correos salen de:</b> usuario@tuempresa.com
                        <br/>
                        <small>Respuestas del cliente llegan a: usuario@tuempresa.com</small>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-4">
                    <div class="col-10">
                      <div class="d-flex justify-content-between">
                        <div class="d-flex align-items-center">
                          <div class="bolita mr-2">
                            .
                          </div>
                          <div class="status">
                            <span v-if="mail_status == 0">Activo</span>
                            <span v-if="mail_status == 1">Error</span>
                          </div>
                        </div>
                        <div class="ml-auto">
                          <button class="btn btn-outlined p-2 d-flex align-items-center" type="button" style="height:auto; font-size:12px;" @click="testConection('smtp')" v-if="mail_subtype == 1">
                            <i class="fas fa-redo mr-1"></i>
                            REVISAR CONEXIÓN
                          </button>

                          <button class="btn btn-outlined p-2 d-flex align-items-center" type="button" style="height:auto; font-size:12px;" @click="testConection('spf')" v-if="mail_subtype == 2">
                            <i class="fas fa-redo mr-1"></i>
                            REVISAR CONEXIÓN
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- FIN Seccion card izquierdo -->
        <div class="col-xl-5 col-lg-7 col-md-12 col-sm-12 col-12 mt-xl-0 mt-lg-0 mt-md-3 mt-sm-3 mt-3"  v-if="showRightContent">
          <div class="cotizarlo-general-wrapper">
            <div class="card-body px-4 py-4">
              <div v-if="rightContentType == 2">
                <div class="row mb-4">
                  <div class="col-12">
                    <h3 class="subtitle-section mb-0">Instrucciones para verificar tu correo</h3>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-12">
                    <p class="spf-main-cont mb-0">
                      Verificar tu correo es un paso sencillo, sin embargo, requiere conocimiento sobre las preferencias de tu dominio. Asegúrate de contactar a tu equipo de sistemas previo a realizar el siguiente ajuste. 
                      <br>
                      <br>
                      Debemos crear un registro SPF en las DNS de tu dominio. Un registro SPF le dice al mundo quién puede enviar correos electrónicos desde su dominio. Puede reducir el riesgo de que los correos electrónicos sean capturados como spam agregando un registro de Cociente SPF en su dominio
                    </p>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-12">
                    <h3 class="spf-subtext strong">Opción 1: <span class="spf-subtext">Crea un nuevo registro SPF</span></h3>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-12">
                    <ol class="list-cot-ol ml-3" type="1">
                      <li>Inicia sesión en su consola de administrador de dominio.</li>
                      <li>Ve a la página donde puedes actualizar los registros DNS.</li>
                      <li>Crea un registro TXT que contenga este texto: v = spf1 includes: _spf.cotizarlo.com ~ all</li>
                      <li>Guarda tus cambios.</li>
                    </ol>  
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-12">
                    <h3 class="spf-subtext strong">Opción 2: <span class="spf-subtext">Modifica tu registro SPF existente</span></h3>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-12">
                    <p class="spf-main-cot mb-0">
                      Si ya tienes un registro SPF creado, actualízalo para incluir el registro de cotizarlo: 
                      <br>
                      <br>
                      Por ejemplo: 
                      <br><br>
                      Si su registro SPF actual es: <strong style="text-decoration: underline;">v=spf1 include:_spf.google.com ~all </strong>
                      <br>
                      Deberás agregarle lo siguiente: <strong style="text-decoration: underline;" class="spf-highlight"> include:_spf.cotizarlo.com </strong>
                      <br>
                      <br>
                      Tu SPF record final debería verse así: <strong style="text-decoration: underline;"> v=spf1 include:_spf.google.com <strong style="text-decoration: underline;" class="spf-highlight"> include:_spf.cotizarlo.com </strong> ~all</strong>
                    </p>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-12">
                    <h3 class="spf-subtext strong">Comprueba tu trabajo</h3>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <p class="spf-main-cont">
                      Tus ajustes pueden tardar hasta 48 horas en propagarse por el mundo, sin embargo, puedes revisar el estado de tu SPF record refrescando esta página y comprobando que la conexión haya sido exitosa.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import data from "@/mixins/data";
import methods from "@/mixins/methods";
import clientConfigService from "@/api/clients";

import { validationMixin } from 'vuelidate'
import { required, numeric,email } from 'vuelidate/lib/validators'

export default {
  mixins: [data, methods,validationMixin],
  components: {},
  beforeMount() {
    this.$store.dispatch("showLoader", { show: true });
    clientConfigService.getMailSendConfiguration().then((response) => {
      
      this.$store.dispatch("showLoader", { show: false });
      if (response.data.data != null) {
        if (response.data.data.use_own_mail == 1){
          this.mail_type = 1;
          this.mail_subtype = 1;
          this.mail_configuration_smtp.host = response.data.data.host;
          this.mail_configuration_smtp.port = parseInt(response.data.data.port);
          this.mail_configuration_smtp.username = response.data.data.username;
          this.mail_configuration_smtp.encryption = response.data.data.encryption;
          this.mail_configuration_smtp.address = response.data.data.address;
          this.mail_configuration_smtp.sender = response.data.data.sender;
          this.mail_configuration_smtp.use_own_mail = true;
          this.mail_configuration_smtp.encryption_name = response.data.data.encryption.toUpperCase();
          this.mail_status = response.data.data.failed_email;
        }
        else{
          this.mail_type = 1;
          this.mail_subtype = 2;
          this.mail_status = response.data.data.failed_email;
        }
      } else {
        this.mail_type = 0;
      }
    });
  },
  data() {
    return {
      showRightContent:false,
      rightContentType:0,
      mail_type: 0,
      mail_subtype:0,
      mail_status: 0,
      /* Parametros requeridos para envio smtp */
      mail_configuration_smtp:{
        host:"",
        port:"",
        username:"",
        password:"",
        encryption:"",
        address:"",
        sender:"",
        use_own_mail:false,
        encryption_name:"Selecciona una opción",
        save:true
      },
      encrytion_types:[
        {
          name: "TLS",
          value: "tls"
        },
        {
          name: "SSL",
          value: "ssl"
        }
      ]
    };
  },
  methods: {
    submitForm() {
      
      /* handle para smtp o para spf */
      if(this.mail_type == 1){
        /* Handle para smtp */
        if(this.mail_subtype == 1){
          this.$v.mail_configuration_smtp.$touch()
          if (this.$v.mail_configuration_smtp.$invalid) {
            this.$store.dispatch('showMessage',{
              action:'error',
              message:'Llena todos los campos requeridos'
            });
          }else{
            this.$store.dispatch("showLoader", { show: true });
            clientConfigService.setMailConfiguration(this.mail_configuration_smtp).then(
              () => {
                this.$store.dispatch("showLoader", { show: false });
                this.$store.dispatch('showMessage',{
                  action:'success',
                  message:'Configuración actualizada correctamente'
                });
              }
            );
          }
        }else{
          this.submitSpfForm();
        }
      }else{
        /* handle para usar cotizarlo */
        this.$store.dispatch("showLoader", { show: true });
        let data = {
          use_own_mail:false
        };
        clientConfigService.setMailConfiguration(data).then(
          () => {
            this.$store.dispatch("showLoader", { show: false });
            this.$store.dispatch('showMessage',{
              action:'success',
              message:'Configuración actualizada correctamente'
            });
          }
        )
      }
      
      
    },
    handleMailSubtype(type){
      this.showRightContent = false;
      this.mail_subtype = type;
      if(this.mail_subtype == 1 || this.mail_subtype == 2){
        this.mail_configuration_smtp.use_own_mail = true;
        if(this.mail_subtype == 2){
          this.showRightContent = true;
          this.rightContentType = 2;
        }else{
          this.showRightContent = false;
        }
      }else{
        this.mail_configuration_smtp.use_own_mail = false;
      }
    },
    selectMethod(method){
      this.mail_configuration_smtp.encryption_name = method.name;
      this.mail_configuration_smtp.encryption = method.value;
    },
    testConection(type){
      
      if(type == 'smtp'){
        this.$store.dispatch("showLoader", { show: true });
        let tempSmtpData = {...this.mail_configuration_smtp}
        tempSmtpData.save = false;
        clientConfigService.setMailConfiguration(tempSmtpData).then(
          () => {
            this.$store.dispatch("showLoader", { show: false });
            this.$store.dispatch('showMessage',{
              action:'success',
              message:'Conexión exitosa.'
            });
          }
        );
      }else{
        this.$store.dispatch("showLoader", { show: true });
        clientConfigService.testSPF().then(
          () => {
            this.$store.dispatch("showLoader", { show: false });
            this.$store.dispatch('showMessage',{
              action:'success',
              message:'Conexión exitosa.'
            });
          }
        );
        
      }
    },
    submitSpfForm(){
      this.$store.dispatch("showLoader", { show: true });
      let spfData = {
        use_own_mail:true
      }
      clientConfigService.setMailSpfConfiguration(spfData).then(
        () => {
          this.$store.dispatch("showLoader", { show: false });
          this.$store.dispatch('showMessage',{
            action:'success',
            message:'Configuración actualizada correctamente.'
          });
        }
      );
    }
  },
  validations: {
    mail_configuration_smtp:{
      host:{
        required
      },
      port:{
        required,
        numeric
      },
      username:{
        required,
        email	
      },
      password:{
        required
      },
      encryption:{
        required
      },
      address:{
        required,
        email
      },
      sender:{
        required
      },
      use_own_mail:{
        required
      }
    }
  },
  watch:{
    mail_type(val){
      if(val == "0"){
        this.mail_subtype = 0;
      }
    },
  }
};
</script>
